import api from "./Api";

export const getReceiptImage = async (receiptID) => {
    const response = await api.get(`/receipt/getReceiptImage/${receiptID}`);
    console.log(response.data);
    return response.data;
};

export const addReceiptImage = async (receiptID, imageBase64) => {
    const response = await api.post(`/receipt/addReceiptImage/${receiptID}`, {
        ImageBase64Content: imageBase64,
    });
    return response.data;
};


export const deleteReceiptImage = async (receiptID) => {
    const response = await api.delete(`/receipt/deleteReceiptImage/${receiptID}`);
    return response.data;
};
